export default __webpack_public_path__ + "static/media/spare2.df963e36.png";